export const tooltipContent = {
  // --- Core Info Step ---
  personaName:
    'The public name for your persona. Keep it concise and memorable.',
  archetype:
    "A classic storytelling archetype that best fits your persona's role (e.g., The Mentor, The Villain).",
  summary:
    "A powerful, one-sentence description of the persona's core identity and purpose.",

  // --- Style Form Step ---
  accent:
    "Describe the persona's voice and accent. Be descriptive! e.g., 'A deep, gravelly voice with a slight Southern drawl.'",

  // --- Substance Form Step ---
  core_backstory:
    'What is the single most important event or origin story that shaped who this persona is today?',
  currentProblem:
    'Giving your persona a current problem makes them feel alive and provides immediate motivation for their conversations.',
  longTermDream:
    "This is the persona's ultimate 'why'. What is the grand ambition that drives all of their actions?",
  strongOpinion:
    'A unique or controversial opinion makes a persona more interesting and less predictable.',
  deepestSecret:
    'What is something the persona is afraid of, insecure about, or hides from the world? This adds a layer of vulnerability and depth.',

  // --- Sliders Step (IPIP-NEO Facets) ---
  openness: {
    imagination:
      'High scorers have a vivid imagination and are often lost in thought. Low scorers are more down-to-earth.',
    artisticInterests:
      'High scorers love beauty, art, and music. Low scorers are less interested in aesthetics.',
    emotionality:
      'High scorers are very aware of their own feelings. Low scorers are less in touch with their emotional state.',
    adventurousness:
      'High scorers love novelty and new experiences. Low scorers prefer routine and the familiar.',
    intellect:
      'High scorers are intellectually curious and love complex ideas. Low scorers prefer concrete and simple topics.',
    liberalism:
      'High scorers are ready to challenge authority and tradition. Low scorers prefer the stability of convention.',
  },
  conscientiousness: {
    selfEfficacy:
      'High scorers believe they are competent and capable. Low scorers often doubt their own abilities.',
    orderliness:
      'High scorers are neat and well-organized. Low scorers are more comfortable with chaos and clutter.',
    dutifulness:
      'High scorers have a strong sense of moral obligation. Low scorers are more casual about their duties.',
    achievementStriving:
      'High scorers have a strong drive to succeed. Low scorers are less ambitious and more content.',
    selfDiscipline:
      'High scorers can power through difficult tasks. Low scorers are more likely to procrastinate.',
    cautiousness:
      'High scorers think carefully before acting. Low scorers are more impulsive and spontaneous.',
  },
  extraversion: {
    friendliness:
      'High scorers are warm and make friends easily. Low scorers are more distant and reserved.',
    gregariousness:
      'High scorers love the buzz of social gatherings. Low scorers prefer solitude or small groups.',
    assertiveness:
      'High scorers are dominant and take charge. Low scorers are more likely to let others lead.',
    activityLevel:
      'High scorers live a fast-paced life. Low scorers prefer a more relaxed pace.',
    excitementSeeking:
      'High scorers are thrill-seekers. Low scorers avoid risks and loud excitement.',
    cheerfulness:
      'High scorers are naturally optimistic and joyful. Low scorers are less prone to high spirits.',
  },
  agreeableness: {
    trust:
      "High scorers believe the best in others. Low scorers are more skeptical of others' intentions.",
    morality:
      'Describes straightforwardness. High scorers are frank and sincere. Low scorers are more willing to manipulate others.',
    altruism:
      'High scorers actively enjoy helping others. Low scorers are more focused on their own needs.',
    cooperation:
      'High scorers dislike confrontation. Low scorers are more willing to assert their own will.',
    modesty:
      "High scorers are humble and don't like to show off. Low scorers see themselves as superior.",
    sympathy:
      "High scorers are tender-hearted and moved by others' suffering. Low scorers are more analytical and less affected by emotion.",
  },
  neuroticism: {
    anxiety:
      'High scorers are often worried and tense. Low scorers are calm and fearless.',
    anger:
      'High scorers are easily angered and frustrated. Low scorers are slow to anger.',
    depression:
      'High scorers are prone to feelings of sadness. Low scorers are not.',
    selfConsciousness:
      'High scorers are sensitive to what others think of them. Low scorers are not easily embarrassed.',
    immoderation:
      'High scorers have a hard time resisting cravings. Low scorers have strong impulse control.',
    vulnerability:
      'High scorers are easily overwhelmed by stress. Low scorers are resilient and handle crises well.',
  },
};
